import React from "react";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { Redirect } from "react-router";
import * as R from "ramda";

import { Alert } from "antd";

const CLAIM_TASK = gql`
    mutation ClaimTaskQuery($id: Int!) {
        claimTask(taskId: $id) {
            __typename
        }
    }
`;

class ClaimHumanTask extends React.Component {
    state = {
        responseType: null,
    };

    isMounted = false;

    componentDidMount = async () => {
        this.isMounted = true;

        const taskId = this.props.match.params.id;

        const { data } = await this.props.mutate({
            variables: {
                id: taskId,
            },
            fetchPolicy: "no-cache",
        });
        const responseType = R.path(["claimTask", "__typename"], data);

        if (this.isMounted && responseType) {
            this.setState({
                responseType,
            });
        }
    };

    componentWillUnmount() {
        this.isMounted = false;
    }

    render() {
        const taskId = this.props.match.params.id;

        switch (this.state.responseType) {
            case "ClaimTaskSuccess":
            case "ClaimTaskFailAssigned":
                return (
                    <React.Fragment>
                        <Alert
                            message="Task assigned, redirecting you to the task..."
                            type="success"
                            showIcon
                        />
                        <Redirect to={`/tasks/${taskId}/`} />
                    </React.Fragment>
                );
            case "ClaimTaskFailExists":
                return (
                    <Alert
                        message="Task does not exist."
                        type="error"
                        showIcon
                    />
                );
            default:
                return (
                    <Alert message="Assigning task..." type="info" showIcon />
                );
        }
    }
}

export default graphql(CLAIM_TASK)(ClaimHumanTask);
